export default __webpack_public_path__ + "static/media/730.06c94f7d.gif";